var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"main-content"},[_c('div',{staticClass:"withdrawal-area"},[_c('p',[_vm._v("退会しました。")]),_c('p',[_c('router-link',{staticClass:"pure-button",attrs:{"to":{ name: 'index' }}},[_vm._v("最初の画面に戻る")])],1)])])])}
var staticRenderFns = []

export { render, staticRenderFns }